import React from "react";

import FormComponent from "./form";
import Layout from "../Common/Layout";

import "./styles.css";

export const Login = () => {
    return (
        <Layout>
            <FormComponent />
        </Layout>
    );
};
